namespace $.$$ {

	$mol_style_define( $shm_ba_filter_item, {
		display: 'grid',
		gridTemplateColumns: 'minmax(0, 1fr) 32px',
		alignItems: 'center',
		gap: '4px',
		position: 'relative',

		':hover': {
			Only: {
				opacity: 1,
				pointerEvents: 'auto',
			},
		},

		'@': {
			shm_ba_filter_item_status: {
				on: {
					Check: {
						color: $mol_theme.control,
					},
				},
				off: {
					Check: {
						color: $mol_theme.shade,
					},
				},
				exclude: {
					Check: {
						color: '#dc2626',
					},
					Exclude: {
						color: '#dc2626',
					},
				},
			},
		},

		Check: {
			minWidth: 0,
		},

		Label: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 1fr) max-content',
			alignItems: 'baseline',
			gap: '8px',
			minWidth: 0,
			width: '100%',
		},

		Title: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		Count: {
			color: $mol_theme.shade,
			textAlign: 'right',
			whiteSpace: 'nowrap',
		},

		Only: {
			opacity: 0,
			pointerEvents: 'none',
			position: 'absolute',
			right: '90px',
			// top: '50%',
			// transform: 'translateY(-50%)',
			height: '100%',
			zIndex: $mol_layer.hover,
			background: {
				color: $mol_theme.back,
			},
			minHeight: 0,
			minWidth: 0,
			padding: {
				left: '6px',
				right: '6px',
				top: '2px',
				bottom: '2px',
			},
			font: {
				size: '12px',
			},
		},

		Exclude: {
			color: $mol_theme.shade,
		},
	} )

}
